var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    fill: "none",
    viewBox: "2.5 2.5 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F59FF",
    strokeWidth: 7.75,
    d: "M12.07 47.17A35.44 35.44 0 0 1 47.5 11.74a35.44 35.44 0 0 1 35.43 35.43A35.44 35.44 0 0 1 47.5 82.6a35.44 35.44 0 0 1-35.43-35.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F59FF",
    d: "M58.5 36.21 41.79 52.94l-5.35-5.35a2.83 2.83 0 1 0-4.02 4.02l7.37 7.37a2.83 2.83 0 0 0 4.02 0l18.75-18.76a2.83 2.83 0 0 0 0-4 2.87 2.87 0 0 0-4.04 0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check-circle-outline.7fb97bb6.svg";
export { ForwardRef as ReactComponent };